import { edmCampaign } from '@bingads-webui/edm-campaign';
import { odata } from '@bingads-webui/http-util';

export const addAsset = (payload, cid, aid) => {
  const edmEntity = edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Folders['Default.AddAsset'];

  return edmEntity.$makeCall({ payload }).toPromise();
};

/**
 * Fetches a single Image entity by id via the Campaign V2 OData endpoint.
 * Used after `Folders/Default.AddAsset` to retrieve the CDN-hosted `Url`
 * (the AddAsset response only carries the new asset id).
 *
 * @param {string|number} cid - Customer id.
 * @param {string|number} aid - Account id.
 * @param {string|number} assetId - Image asset id returned by AddAsset.
 * @param {object} odataOptions - host/path/oDataToken/contentType options
 *   passed through from `useOdataOptions()` so the request goes to the
 *   correct OData endpoint.
 * @returns {Promise<object>} The Image entity (Url, Text, Width, Height, ...).
 */
export const getImageById = (cid, aid, assetId, odataOptions) => {
  const url = `/Customers(${cid})/Accounts(${aid})/Images(${assetId})`;
  return odata.get(url, { ...odataOptions });
};

/**
 * Calls `Folders/Default.DeleteAsset` to remove an image from the Asset
 * Library. Mirrors the request body the BingAds Asset Library UI sends:
 *   { Asset: { '@odata.type': '#Model.Image', Id: <numeric assetId> } }
 *
 * @param {string|number} cid - Customer id.
 * @param {string|number} aid - Account id.
 * @param {string|number} assetId - Image asset id to delete.
 * @returns {Promise<object>} The OData response.
 */
export const deleteAsset = (cid, aid, assetId) => {
  const edmEntity = edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Folders['Default.DeleteAsset'];

  const payload = {
    Asset: {
      '@odata.type': '#Model.Image',
      Id: Number(assetId),
    },
  };

  return edmEntity.$makeCall({ payload }).toPromise();
};
